import React from "react";



const FooterLogo =()=>{


   return(
    <div className="flex justify-content-center align-items-center mt6">
            <img className="h-30" src="https://tahsilat.elogo.com.tr/apipayment/bankIcons/ssl.png"  width={"auto"}  />
            <img className="h-20 ml2"   src="https://tahsilat.elogo.com.tr/apipayment/bankIcons/visa.svg"    />
            <img className="h-30 ml2"  src="https://tahsilat.elogo.com.tr/apipayment/bankIcons/mastercard-footer.svg"    />

    </div>
   );
}

export default FooterLogo;